var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirplaneNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.206,11.739L13.182,8.38L12.73,6.45L16.62,2.56C17.2,1.97 17.2,1 16.62,0.438C16.04,-0.124 15.08,-0.148 14.5,0.438L10.61,4.33L1.41,2.21L0,3.62L7.43,7.5L3.54,11.4L1.06,11.05L0,12.11L3.18,13.87L4.95,17.06L6,16L5.66,13.5L9.55,9.63L10.9,12.22C10.994,12.055 11.096,11.894 11.206,11.739Z",
    style: {
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.996,14.608L12.075,21.996C12.081,22.543 12.526,22.984 13.073,22.985L22.065,23C22.334,23 22.591,22.893 22.779,22.702C22.967,22.511 23.071,22.253 23.067,21.985L22.939,13.669L22.938,13.649L22.921,13.497L22.866,13.31L22.801,13.177L22.713,13.052L19.692,9.355L19.552,9.215L19.398,9.112L19.34,9.083C19.213,9.024 19.071,8.991 18.921,8.991L13.313,8.991L12.73,6.45L16.62,2.56C17.2,2 17.2,1.03 16.62,0.44C16.04,-0.15 15.08,-0.146 14.5,0.44L10.61,4.33L1.41,2.21L0,3.62L7.43,7.5L3.54,11.4L1.06,11.05L0,12.11L3.18,13.87L4.95,17.06L6,16L5.66,13.5L9.55,9.63L10.5,11.455L11.996,14.608ZM17.925,13.735C17.926,14.003 18.033,14.26 18.225,14.448C18.416,14.635 18.674,14.739 18.942,14.734L20.954,14.701C20.954,14.701 21.052,20.998 21.052,20.998C21.052,20.998 14.064,20.987 14.064,20.987C14.064,20.987 13.957,10.991 13.957,10.991C13.957,10.991 17.922,10.991 17.922,10.991C17.922,10.991 17.925,13.735 17.925,13.735Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplaneNote);
export default __webpack_public_path__ + "static/media/airplane-note.69cf6505.svg";
export { ForwardRef as ReactComponent };